<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.the-first-video-section
    t-section
      t-h2(white) {{content.videoHeader}}
      //- t-h3 {{content.subHeader1}}
      +e.video
        youtube(:video-id="videoId")
      +e.links
        +e.A.link(href="https://ti-ukraine.org/research/indeks-koruptsiji-cpi-2012/" target="_blank") 2012
        +e.A.link(href="https://ti-ukraine.org/research/indeks-koruptsiji-cpi-2013/" target="_blank") 2013
        +e.A.link(href="https://ti-ukraine.org/research/indeks-koruptsiji-cpi-2014/" target="_blank") 2014
        +e.A.link(href="https://ti-ukraine.org/research/indeks-koruptsiyi-cpi-2015/" target="_blank") 2015
        +e.A.link(href="https://ti-ukraine.org/research/indeks-koruptsiyi-cpi-2016/" target="_blank") 2016
        +e.A.link(href="https://ti-ukraine.org/research/indeks-koruptsiyi-cpi-2017/" target="_blank") 2017
</template>

<script>
import { mapGetters } from 'vuex';

import TSection from '@/components/TSection/TSection';
import TH2 from '@/components/TH2/TH2';
import TH3 from '@/components/TH3/TH3';

export default {
  name: 'the-first-video-section',

  computed: {
    videoId() {
      return this.$youtube.getIdFromURL('https://youtu.be/JE-OlnHV-W0');
    },

    ...mapGetters({
      content: 'getContent',
    }),
  },

  components: {
    TSection,
    TH2,
    TH3,
  },
};
</script>

<style lang="scss">
@import '../../scss/styles';

.the-first-video-section {
  &__text {
    color: #ffffff;
    font-weight: 100;
  }

  &__video {
    margin-top: 64px;
  }

  &__links {
    position: relative;
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 20px;
    margin-top: 40px;

    &:before {
      content: '';
      position: absolute;
      width: calc(100% - 50px);
      height: 2px;
      background-color: #3695D8;
      top: 35px;
      left: 25px;
      z-index: 1;
    }
  }

  &__link {
    color: #ffffff;
    text-decoration: none;
    background-color: $color-bg;
    font-size: 16px;
    line-height: 16px;
    border-radius: 16px;
    padding: 6px 10px;
    font-weight: 600;
    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
    z-index: 2;
    border: solid 2px #3695D8;

    &:hover {
      background-color: #3695D8;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/TheFirstVideoSection/TheFirstVideoSection.vue